export const state = {
    tokeninfo: {},
};

export const getters = {
};

export const mutations = {
    set_token_info(state, tokeninfo) {
        state.tokeninfo = tokeninfo
    }
};

